module.exports = __webpack_public_path__ + "img/Pelletlager.81df211.png";